import { render, staticRenderFns } from "./create-company.vue?vue&type=template&id=f2255ba8&scoped=true"
import script from "./create-company.vue?vue&type=script&lang=js"
export * from "./create-company.vue?vue&type=script&lang=js"
import style0 from "./create-company.vue?vue&type=style&index=0&id=f2255ba8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2255ba8",
  null
  
)

export default component.exports